export default __webpack_public_path__ + "static/media/bittrex-logo-white.8692899b.svg";